import { Descriptions } from "antd";
import type { Subcategory } from "../../../../../app/features/admin/admin.types";
import CustomModal from "../../../../../components/CustomModal";
import StatusTag from "../../../../../components/StatusTag";
import type { ModalType } from "../../../../../hooks/useModal";
import { formatDate } from "../../../../../utils/time.utils";

interface SubcategoryDetailsProps {
  open: boolean;
  onCancel: () => void;
  subcategory?: Subcategory | null;
  type?: ModalType["type"];
}

const SubcategoryDetails = ({
  open,
  onCancel,
  subcategory,
}: SubcategoryDetailsProps) => {
  if (!subcategory) return null;

  return (
    <CustomModal
      title="Subcategory Details"
      open={open}
      handleClose={onCancel}
      footer={null}
      width={500}
    >
      <Descriptions column={1} bordered>
        <Descriptions.Item label="ID">{subcategory.id}</Descriptions.Item>
        <Descriptions.Item label="Category">
          {subcategory.Category?.name || "N/A"}
        </Descriptions.Item>
        <Descriptions.Item label="Name">{subcategory.name}</Descriptions.Item>
        {/* <Descriptions.Item label="Slug">{subcategory.slug}</Descriptions.Item> */}
        <Descriptions.Item label="Sort Order">
          {subcategory.sortOrder}
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <StatusTag
            value={subcategory.isActive ? "active" : "inactive"}
            config={[
              { value: "active", label: "Active", className: "status-success" },
              {
                value: "inactive",
                label: "Inactive",
                className: "status-error",
              },
            ]}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Created At">
          {formatDate(subcategory.createdAt)}
        </Descriptions.Item>
        <Descriptions.Item label="Updated At">
          {formatDate(subcategory.updatedAt)}
        </Descriptions.Item>
      </Descriptions>
    </CustomModal>
  );
};

export default SubcategoryDetails;
